"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SFTPSLLimiterUtils = void 0;
var SFTPSLLimiterUtils;
(function (SFTPSLLimiterUtils) {
    function profitRateToPriceParams(originParams, rate) {
        const { triggerPrice, takerFee, leverageD, priceByRateSide } = originParams;
        return {
            takerFee: takerFee.toNumber(),
            leverage: leverageD.toNumber(),
            rate: rate,
            side: priceByRateSide,
            triggerPrice: triggerPrice,
        };
    }
    SFTPSLLimiterUtils.profitRateToPriceParams = profitRateToPriceParams;
})(SFTPSLLimiterUtils = exports.SFTPSLLimiterUtils || (exports.SFTPSLLimiterUtils = {}));
